/**
 * RELATÓRIO DE CAIXA — o dinheiro da gaveta bateu?
 *
 * Por turno e por loja: fundo de troco, recebido por forma de pagamento,
 * sangrias, repique, ESPERADO, contado e DIFERENÇA. Cartão, PIX, vale e fiado
 * saem em colunas separadas e FORA do esperado — fiado é receita e nunca entrou
 * na gaveta (§7.0).
 *
 *     esperado = fundo de troco + recebido em dinheiro − sangrias
 *
 * Sem subtrair repique: **repique é receita da casa** (decisão do dono). É essa
 * decisão que torna a coluna `diferença` publicável.
 *
 * O que esta tela mostra no dado real de hoje, e mostra de propósito: 5 das 6
 * linhas de fechamento do OPS valem literalmente a string `[object Object]`.
 * As células ficam VAZIAS com a explicação, e o aviso FECHAMENTO_ILEGIVEL traz
 * a contagem. Zero ali diria "conferi e deu zero", e ninguém conferiu.
 *
 * SÓ LEITURA (§5.1).
 */
import React, { useMemo } from "react";
import * as AlfredoStyles from "../styles/components/CashReport";
import * as AlfredoComponents from "./";
import { relatorioService } from "../services/relatorio.service";
import { useRelatorio } from "../hooks/useRelatorio";

const CAMPOS = ["de", "ate", "turno"];

const buscarCaixa = relatorioService.caixa.bind(relatorioService);

const CashReport: React.FC = () => {
  const relatorio = useRelatorio(buscarCaixa, CAMPOS);

  const turnos = useMemo(() => {
    const nomes = new Set<string>();
    (relatorio.envelope?.linhas ?? []).forEach((linha: any) => {
      if (linha.turno) nomes.add(String(linha.turno));
    });
    return Array.from(nomes);
  }, [relatorio.envelope]);

  return (
    <AlfredoStyles.CashReportContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>point_of_sale</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Relatório de Caixa</AlfredoStyles.Title>

        <AlfredoComponents.CarimboDoDado
          carimbo={relatorio.envelope?.carimbo}
          fonte={relatorio.envelope?.fonte}
          semVenda
        />

        <AlfredoComponents.FiltrosDoRelatorio
          de={relatorio.filtro.de}
          ate={relatorio.filtro.ate}
          turno={relatorio.filtro.turno}
          canal=""
          visao=""
          turnos={turnos}
          mostrarVisoes={false}
          aoMudar={relatorio.mudarFiltro}
          aoLimpar={relatorio.limparFiltro}
        />

        {/* Aberto de saída: sem ler os avisos, a coluna vazia de `contado`
            parece bug em vez de ausência de fechamento cego. */}
        <AlfredoComponents.AvisosDoRelatorio
          avisos={relatorio.envelope?.avisos}
          comecarAberto
        />

        <AlfredoComponents.DynamicTable
          tableType={0}
          handleOpenModal={() => undefined}
          rows={relatorio.linhas}
          columns={relatorio.colunas}
          getRowId={(linha) => String(linha.chave)}
          title="Fechamento por turno"
          hideCreateButton
          hideImportButton
          hideRowActions
          isLoading={relatorio.carregando}
          error={relatorio.erro}
          emptyMessage="Nenhum turno no período escolhido."
        />

        {relatorio.envelope && (
          <AlfredoComponents.RodapeDaFonte envelope={relatorio.envelope} />
        )}
      </AlfredoStyles.Card>
    </AlfredoStyles.CashReportContainer>
  );
};

export default CashReport;
